$(document).ready(function () {
    // Enables autogrow (but only on textareas without the .no-autogrow class)
    $('textarea:not(.no-autogrow)').autogrow({
        onInitialize: true,
    });

    $('#btn-close').bind('click', function (e) {
        $.closest('.modal').modal('hide');
        e.preventDefault();
    });

    // Turn on tooltips
    $(document).tooltip({
        selector: '[data-toggle="tooltip"]',
    });

    // Turn on popovers
    $('[data-toggle="popover"]').popover();
    $(document).on('click', '.popover .btn-close', function () {
        var popover = $(this).parents('a').find('icon-gear').popover('hide');
    });

    // Date and time formats used by date pickers, timetable plugins and the like
    window.DATE_PICKER_FORMAT = 'YYYY/MM/DD';
    window.TIME_PICKER_FORMAT = 'HH:mm';
    window.DATE_TIME_PICKER_FORMAT = DATE_PICKER_FORMAT + ' ' + TIME_PICKER_FORMAT;

    window.LONGDATE = 'MMMM Do YYYY';
    window.MEDIUMDATE = 'MMM D YYYY';
    window.SHORTDATE = 'ddd D MMMM';
    window.TIME = 'HH:mm';

    // Enable rudimentary date picker inputs
    $('input[type="hidden"][data-toggle="datepicker"]').val(dayjs().format(DATE_PICKER_FORMAT)).datetimepicker({
        inline: true,
        todayButton: true,
        timepicker: false,
        dayOfWeekStart: 1,
        format: 'Y/m/d',
    });

    // Get the input element we want to add a date time picker to
    var textDatePicker = $('input[type="text"][data-toggle="datepicker"]');

    // If a input value has not already been given then initialise with the current date
    if (textDatePicker.val() === '') {
        textDatePicker.val(dayjs().format(DATE_PICKER_FORMAT));
    }

    // Add the date picker
    textDatePicker.datetimepicker({
        inline: false,
        todayButton: true,
        timepicker: false,
        dayOfWeekStart: 1,
        format: 'Y/m/d',
    });

    $('input[type="hidden"][data-toggle="datetimepicker"]').val(dayjs().format(DATE_TIME_PICKER_FORMAT)).datetimepicker({
        inline: true,
        todayButton: true,
        timepicker: true,
        dayOfWeekStart: 1,
        format: 'Y/m/d H:i',
    });

    $('input[type="text"][data-toggle="datetimepicker"]').val(dayjs().format(DATE_TIME_PICKER_FORMAT)).datetimepicker({
        inline: false,
        todayButton: true,
        timepicker: true,
        dayOfWeekStart: 1,
        format: 'Y/m/d H:i',
    });

    // Initialise datetimepicker for date of birth field and set the default year to 18 years ago
    var minDOB = dayjs().subtract(18, 'year').format('YYYY/MM/DD');
    $('#dob, #request-date-of-birth').datetimepicker({
        timepicker: false,
        format: 'd/m/Y',
        startDate: minDOB,
        maxDate: '+1970/01/01',
    });

    if ($('.dtpicker').length != 0) {
        $('.dtpicker').datetimepicker({
            format: 'Y/m/d H:i',
            minDate: 0,
        });
    }

    // Select all checkboxes on page
    $(document).on('click', '.select_all', function () {
        var checked = this.checked;
        $(':checkbox').prop('checked', checked);
    });

    // Enable select2 on any select boxes with the .select2 class
    $('select.select2').select2({
        width: '100%',
        theme: 'bootstrap',
    });

    // Fix for Select2 focus missing from input caused by
    // Bootstrap modal tabindex=-1
    // See https://github.com/select2/select2/issues/600#issuecomment-102857595
    $.fn.modal.Constructor.prototype.enforceFocus = $.noop;

    $('.show-sidebar').click(function () {
        $('.sidebar').toggle(null, { direction: 'right' }, 500);
    });

    $('.modal').on('shown.bs.modal', function (e) {
        $(e.target).find('textarea').autogrow({ onInitialize: true });
    });

    var editor = $('[data-toggle="wysiwyg-editor"]');
    var editor2 = $('[data-toggle="wysiwyg-editor2"]');

    var commandName = 'insertText';
    if (document.all || !!window.MSInputMethodContext && !!document.documentMode) {
        // IE11
        commandName = 'paste';
    }

    window.default_options = {
        minHeight: 400,
        styleTags: ['p', 'h1', 'h2', 'h3'],
        toolbar: [
            ['insert', ['table', 'link']],
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['font', ['strikethrough', 'superscript', 'subscript']],
            ['para', ['ul', 'ol']],
            ['misc', ['undo', 'redo']],
        ],
        placeholder: $(editor).attr('placeholder'),
        prettifyHtml: true,
        disableDragAndDrop: true,
        callbacks: {
            onPaste: function (e) {
                var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('text/plain');

                e.preventDefault();

                if (document.execCommand) {
                    document.execCommand('insertText', false, bufferText);
                } else {
                    e.target.value += bufferText;
                }
            },
        },
    };

    editor.summernote(default_options);
    default_options.placeholder = $(editor2).attr('placeholder');
    editor2.summernote(default_options);

    // Change the syntax of the underscore templating engine to use handlebars-esque templating
    // This is because we're parsing HTML and it breaks the template compilation otherwise
    _.templateSettings = {
        interpolate: /\{\{(.+?)\}\}/g,
        escape: /\{\{-(.+?)\}\}/g,
        evaluate: /\{(.+?)\}/g,
    };
    // Initialise tooltips
    $('[data-toggle="tooltip"]').tooltip();
});

const programmeYears = [1, 2, 3, 4, 5];

export { programmeYears };
